import { Button } from "@mui/material";
import './style.css';
import Footer from '../../Components/Footer';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
export default function Promos() {
  return (
    <div>
      <div className='ourBrand'>
        <h2>Nos Bons Plans pour vous</h2>
        <div className='promoGrid'>
          {itemData.map((item) => (
            <div className={`images-zoom-container `}>
              <div className='promoContainer'>
                <a href={`/bons-plans/${item}`}>
                <img
                  src={require(`../../images/promos/${item}.jpg`)}
                  alt={item}
                  className='promoImg'
                />
                <Button endIcon={<ArrowRightAltIcon/>} color='warning' className='promoButton'>Profiter</Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

const itemData = [
 "1","2","3","4","5","6","7","8","9","10","11","12","13"
];
